/**
 * Keeps the bag icon inside the product page's add-to-cart button.
 *
 * Why this exists: variant-picker.js:90 does `addBtn.textContent = …` on every variant change,
 * which removes every child of the button. The icon cannot be a pseudo-element instead, because
 * main.css:3998 and main.css:4015 already use [name=add]::before for the loading spinner and
 * ::after for the success tick (both position:absolute + opacity:0).
 *
 * The span is server-rendered by sections/main-product.liquid, so there is no first-paint flash;
 * this only clones it back after the theme wipes it.
 */
(() => {
  const buttons = document.querySelectorAll('.pdp-main .js-product-form .add-to-cart');

  buttons.forEach((btn) => {
    const original = btn.querySelector('[data-atc-icon]');
    if (!original) return;

    const template = original.cloneNode(true);

    const restore = () => {
      // Appending re-triggers the observer; the guard makes that pass a no-op, so it terminates.
      if (btn.querySelector('[data-atc-icon]')) return;
      btn.appendChild(template.cloneNode(true));
    };

    new MutationObserver(restore).observe(btn, { childList: true });
  });
})();
